import { handleActions } from 'redux-actions';
import moment from 'moment';

import * as types from './types';

const initialState = {
  data: {},
  error: null,
  initialLoad: false,
  lastSync: null,
  loading: false,
  logo: null,
  saving: false,
};

const deactivateCompanyRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const deactivateCompanyRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const deactivateCompanyRequestSuccess = (state, payload) => ({
  ...state,
  data: payload.data,
  error: null,
  saving: false,
});

const getCompanyRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const getCompanyRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
});
const getCompanyRequestSuccess = (state, payload) => ({
  ...state,
  data: payload.data,
  error: null,
  initialLoad: true,
  lastSync: moment().toISOString(),
  loading: false,
});

const getCompanyLogoRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const getCompanyLogoRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
});
const getCompanyLogoRequestSuccess = (state, payload) => ({
  ...state,
  logo: payload.data,
  error: null,
  loading: false,
});

const selectCompanyEntityRequest = (state) => ({
  ...state,
  error: null,
  loading: false,
  saving: true,
});
const selectCompanyEntityRequestFailure = (state, action) => ({
  ...state,
  error: action.error.message,
  loading: false,
  saving: false,
});
const selectCompanyEntityRequestSuccess = (state, payload) => ({
  ...state,
  error: null,
  loading: false,
  saving: false,
});

const updateCompanyRequest = (state) => ({
  ...state,
  error: null,
  loading: false,
  saving: true,
});
const updateCompanyRequestFailure = (state, action) => ({
  ...state,
  error: action.error.message,
  loading: false,
  saving: false,
});
const updateCompanyRequestSuccess = (state, payload) => ({
  ...state,
  data: { ...payload.data },
  error: null,
  loading: false,
  saving: false,
});

export default handleActions(
  {
    [types.DEACTIVATE_COMPANY_REQUEST]: deactivateCompanyRequest,
    [types.DEACTIVATE_COMPANY_REQUEST_FAILURE]: deactivateCompanyRequestFailure,
    [types.DEACTIVATE_COMPANY_REQUEST_SUCCESS]: deactivateCompanyRequestSuccess,
    [types.GET_COMPANY_REQUEST]: getCompanyRequest,
    [types.GET_COMPANY_REQUEST_FAILURE]: getCompanyRequestFailure,
    [types.GET_COMPANY_REQUEST_SUCCESS]: getCompanyRequestSuccess,
    [types.GET_COMPANY_LOGO_REQUEST]: getCompanyLogoRequest,
    [types.GET_COMPANY_LOGO_REQUEST_FAILURE]: getCompanyLogoRequestFailure,
    [types.GET_COMPANY_LOGO_REQUEST_SUCCESS]: getCompanyLogoRequestSuccess,
    [types.SELECT_COMPANY_ENTITY_REQUEST]: selectCompanyEntityRequest,
    [types.SELECT_COMPANY_ENTITY_REQUEST_FAILURE]: selectCompanyEntityRequestFailure,
    [types.SELECT_COMPANY_ENTITY_REQUEST_SUCCESS]: selectCompanyEntityRequestSuccess,
    [types.UPDATE_COMPANY_REQUEST]: updateCompanyRequest,
    [types.UPDATE_COMPANY_REQUEST_FAILURE]: updateCompanyRequestFailure,
    [types.UPDATE_COMPANY_REQUEST_SUCCESS]: updateCompanyRequestSuccess,
  },
  initialState
);
